import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { BASE_URL } from '../../App';
import { Select, Table, Image, Card, Typography, Spin, Switch, message } from 'antd';
import { Backdrop, CircularProgress } from '@mui/material';

const { Title } = Typography;
const { Option } = Select;

export default function ItemCodeImageManager() {
    const [itemCodes, setItemCodes] = useState([]);
    const [selectedItemCode, setSelectedItemCode] = useState(null);
    const [imagesDetails, setImagesDetails] = useState([]);
    const [spinning, setSpinning] = useState(false);
    const [loading, setLoading] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const login_id = localStorage.getItem("LOGIN_ID");

    useEffect(() => {
        setImagesDetails([]);
        setSelectedItemCode(null);

        SisoItemCodeLoad();
    }, []);

    const AlertMsg = (type, msg, duration) => {
        messageApi.open({
            type: type,
            content: msg,
            duration: duration,
        });
    };

    const SisoItemCodeLoad = () => {
        setSpinning(true);
        const data = {
            type: "SisoMaterialCodeLoad"
        }

        axios.post(BASE_URL + '/siso_uploads', data)
            .then(response => {
                const ItemCodes = response.data.message;
                setItemCodes(ItemCodes);
            }).catch(error => {
                AlertMsg("warning", error?.response?.data?.message || "Error fetching data", 2);
            }).finally(() => {
                setSpinning(false);
            });
    }

    const ItemCodeChange = (value) => {
        setSelectedItemCode(value);
        setImagesDetails([]);

        if (value) {
            setSpinning(true);
            const data = {
                type: "MaterialCodeImagesLoad",
                ItemCode: value,
            }

            axios.post(BASE_URL + '/siso_uploads', data)
                .then(response => {
                    const itemList = response.data.message;
                    const formattedItems = itemList.map(item => ({ ...item, key: item.ImgId, }));

                    setImagesDetails(formattedItems);
                }).catch(error => {
                    AlertMsg("warning", error?.response?.data?.message || "Error fetching data", 2);
                }).finally(() => {
                    setSpinning(false);
                });
        }
    }

    const handleStatusChange = (imgId, checked) => {
        setSpinning(true);
        const status = checked ? '1' : '0';
        const payload = {
            type: "UpdateMaterialImageStatus",
            IMGID: imgId,
            Status: status,
            selectedItemCode: selectedItemCode,
            LOGIN_ID: login_id,
        };

        axios.post(BASE_URL + '/siso_uploads', payload)
            .then(() => {
                setImagesDetails(prev =>
                    prev.map(item =>
                        item.ImgId === imgId ? { ...item, Status: status } : item
                    )
                );
                AlertMsg("success", "Status updated successfully", 2);
            })
            .catch(err => {
                AlertMsg("warning", err?.response?.data?.message || "Status update failed", 2);
            }).finally(() => {
                setSpinning(false);
            });
    };

    const headerCellStyle = {
        border: '1px solid #ddd',
        padding: '12px',
        fontWeight: 'bold',
        textAlign: 'center',
        backgroundColor: '#f0f2f5',
    };

    const cellStyle = {
        border: '1px solid #ddd',
        padding: '12px',
        textAlign: 'center',
    };

    return (
        <>
            {contextHolder}
            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={spinning} >
                <CircularProgress color="inherit" />
            </Backdrop>

            <Card bordered style={{ borderRadius: 10, padding: 20 }}>
                <Title level={4}><center>SISO Material Image Mapping Mapper</center></Title>
                <hr />
                <div style={{ marginBottom: 20 }}>
                    <label style={{ fontWeight: 'bold' }}>Select Material Code: </label>
                    <Select
                        placeholder="Select an item code"
                        style={{ width: 250, marginLeft: 10 }}
                        onChange={ItemCodeChange}
                        value={selectedItemCode}
                    >
                        {itemCodes.map((code) => (
                            <Option key={code.ItemCode} value={code.ItemCode}>
                                {code.ItemCode}
                            </Option>
                        ))}
                    </Select>
                </div>

                {selectedItemCode ? (
                    imagesDetails.length > 0 ? (
                        <div style={{ overflowX: 'auto' }}>
                            <table style={{ width: '100%', borderCollapse: 'collapse', borderRadius: '8px', overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
                                <thead style={{ backgroundColor: '#fafafa' }}>
                                    <tr>
                                        <th style={headerCellStyle}>Image</th>
                                        <th style={headerCellStyle}>Image Name</th>
                                        <th style={headerCellStyle}>Status</th>
                                        <th style={headerCellStyle}>Created On</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {imagesDetails.map((item) => (
                                        <tr key={item.ImgId} style={{ backgroundColor: '#fff', transition: 'background 0.3s' }}>
                                            <td style={cellStyle}>
                                                <Image
                                                    src={item.ImagePath}
                                                    width={60}
                                                    preview={true} // default is true, but explicit helps debug
                                                />
                                            </td>
                                            <td style={cellStyle}>{item.ImageName}</td>
                                            <td style={cellStyle}>
                                                <Switch
                                                    checked={item.Status === '1'}
                                                    onChange={(checked) => handleStatusChange(item.ImgId, checked)}
                                                />
                                            </td>
                                            <td style={cellStyle}>
                                                {new Date(item.CreatedOn).toLocaleString()}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <p style={{ marginTop: 20 }}>No images found for this item code.</p>
                    )
                ) : (
                    <p style={{ marginTop: 20 }}>Please select an item code.</p>
                )}
            </Card>
        </>
    );
}
